import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

type StylesTypes = {
  isLiftStationMobile?: boolean;
};

const StyledLabelOnBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLiftStationMobile',
})(({ isLiftStationMobile }: StylesTypes) => ({
  display: 'inline-block',
  background: 'rgba(5, 182, 178, 0.08)',
  padding: isLiftStationMobile ? '2px 6px' : '2px 8px',
  borderRadius: '6px',
}));

const StyledLabelText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isLiftStationMobile',
})(({ isLiftStationMobile }: StylesTypes) => ({
  color: '#05b6b2',
  fontSize: isLiftStationMobile ? '10px' : '12px',
  fontWeight: '700',
}));

export { StyledLabelOnBox, StyledLabelText };
